import { Props } from '@/ui/components/Paginator/types';
import { Paginator as NewPaginator } from '@/ui/Paginator/Paginator';

/**
 * @deprecated Do not use this component. Use the base components at the root of the UI folder instead.
 */
const Paginator = ({ currentPage, goToPage, nextPage, prevPage, totalPages }: Props) => {
  const handlePageChange = (page: number) => {
    if (page === 1) goToPage(1);
    else if (page === totalPages) goToPage(totalPages);
    else if (page === currentPage - 1) prevPage();
    else if (page === currentPage + 1) nextPage();
    else goToPage(page);
  };

  return (
    <NewPaginator
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={handlePageChange}
    />
  );
};

export default Paginator;
